import React from 'react';
import DrawerContext from './context';

const useDrawer = () => {
  return  React.useContext(DrawerContext);
}

export default useDrawer;
